import store, { useCurShop, usePlat, useToken } from './store'

export const getAuth = async () => {
  try {
    const res = await fetch('http://localhost:10000/api/auth')
    const { data } = await res.json()
    console.log('getAuth token shopId bizSource', data)
    await store.commit('route/plat', data.bizSource)
    await store.commit('route/curShop', data.shopId)
    await store.commit('route/token', data.token)
    await undefined
  } catch (err) {
  }
}

export const setAuth = async (headers:any) => {
  try {
    const res = await fetch('http://localhost:10000/api/auth', { headers })
  } catch (err) {
  }
}

let count = 0

export default async () => {
  setTimeout(() => {
    count++
  }, 1000)
  if (process.env.NODE_ENV === 'development' && count > 0) {
    const token = useToken() ?? ''
    const shopId = useCurShop() ?? ''
    const bizSource = usePlat() ?? ''
    console.log(`post token ${token} shopId ${shopId} bizSource ${bizSource}`)
    await setAuth({ token, shopId, bizSource, action: 'set' })
  }
}
